var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.22 171 468.8 298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 320c3 0 6-1 8-4 1-1 63-81 205-81a11 11 0 100-22C71 213 5 299 2 303a11 11 0 009 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 171c-48 0-61 24-63 27-2 5 0 11 5 14s12 1 14-4c1-1 10-16 44-16 39 0 43 30 43 43 0 16-18 64-96 64-46 0-73-7-97-13-20-4-38-9-63-9-55 0-157 44-191 113a11 11 0 0019 9c31-60 124-100 172-100 22 0 39 4 58 8 25 6 53 13 102 13 96 0 117-63 117-85 0-30-16-64-64-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 341c-113 0-137 69-138 72a11 11 0 0020 6s20-56 118-56c96 0 139 26 139 53 0 26-18 32-32 32s-30-13-35-18a11 11 0 10-16 15c3 2 26 24 51 24s53-14 53-53c0-36-42-75-160-75z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3f720ce5d7c7d0e5b68c399a2daa3151.svg";
export { ForwardRef as ReactComponent };